import Classification from 'components/report/Classification'
import AuthorRelationshipTypes from 'components/report/AuthorRelationshipTypes'
import PublishedRange from 'components/report/PublishedRange'
import FilterCard from 'components/report/FilterCard'
import FiltersSubmit from 'components/report/FiltersSubmit'
import { Fade, FadeVisual } from 'components/misc/Fade'
import CircleSpinner from 'components/misc/CircleSpinner'
import SearchCites from './SearchCites'
import CitationsYearBarChart from '../misc/CitationsYearBarChart'
import SortBox from '../misc/SortBox'
import ReportCountFilter from './ReportCountFilter'
import { MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import styles from './styles/Filters.css'

const Panels = ({
  publishedRange,
  minMaxPublishedRange,
  setPublishedRange,
  filters,
  sectionCounts,
  journalCounts,
  pubtypeCounts,
  authorCounts,
  toggleFilter,
  toggleModal,
  fullReport,
  upgradeReport,
  authorRelationshipCounts,
  setSort,
  setTextMatch,
  sortOptions,
  references = false,
  yearBins,
  isReferenceCheck
}) => (
  <>
    <FilterCard title={`Search ${references ? 'references' : 'citation statements'}`}>
      <SearchCites
        upgradeReport={upgradeReport}
        fullReport={fullReport}
        toggleModal={toggleModal}
        textMatch={filters.textMatch}
        setTextMatch={setTextMatch}
        debounceMatch
      />
      {setSort && (
        <div className={styles.sortBox}>
          <SortBox
            options={sortOptions}
            sort={filters.sort}
            setSort={setSort}
          />
        </div>
      )}
    </FilterCard>
    {sectionCounts && (
      <FilterCard title='Paper Sections' tooltipCopy='Filter Smart Citations based on what section of the citing paper they appear in.'>
        <ReportCountFilter
          filterValues={filters.sections}
          filterKey='sections'
          toggleFilter={toggleFilter}
          toggleModal={toggleModal}
          counts={sectionCounts}
          fullReport={fullReport}
          upgradeReport={upgradeReport}
        />
      </FilterCard>
    )}
    {
      !isReferenceCheck && (
        <FilterCard title='Citation Types' tooltipCopy="Smart Citations are classified as supporting, mentioning, or contrasting the cited work's findings. You can filter for specific types below.">
          <Classification />
        </FilterCard>
      )
    }
    {
      minMaxPublishedRange && (
        <FilterCard title='Year Published'>
          <div className={styles.yearRange}>
            <CitationsYearBarChart
              yearBins={yearBins}
              selectedRange={publishedRange}
              minMaxPublishedRange={minMaxPublishedRange}
              setPublishedRange={setPublishedRange}
              showTypes={!references}
              objectName={references ? 'References' : 'Citations'}
            />
            <PublishedRange
              publishedRange={publishedRange}
              minMaxPublishedRange={minMaxPublishedRange}
              onChange={val => {
                if (!fullReport) {
                  toggleFilter('showMobile', false)
                  toggleModal(upgradeReport ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_FILTER)
                  return
                }
                setPublishedRange(val)
              }}
              toggleModal={toggleModal}
              fullReport={fullReport}
              upgradeReport={upgradeReport}
              toggleFilter={toggleFilter}
            />
          </div>
        </FilterCard>
      )
    }
    {pubtypeCounts && (
      <FilterCard title='Publication Types'>
        <ReportCountFilter
          filterValues={filters.pubtypes}
          filterKey='pubtypes'
          toggleFilter={toggleFilter}
          toggleModal={toggleModal}
          counts={pubtypeCounts}
          fullReport={fullReport}
          upgradeReport={upgradeReport}
        />

      </FilterCard>
    )}
    {authorRelationshipCounts && (
      <FilterCard title='Relationship'>
        <AuthorRelationshipTypes
          toggleFilter={toggleFilter}
          toggleModal={toggleModal}
          filters={filters}
          counts={authorRelationshipCounts}
          fullReport={fullReport}
          upgradeReport={upgradeReport}
        />
      </FilterCard>
    )}
    {authorCounts && (
      <FilterCard title='Authors' collapsible>
        <ReportCountFilter
          filterValues={filters.authors}
          filterKey='authors'
          toggleFilter={toggleFilter}
          toggleModal={toggleModal}
          counts={authorCounts}
          fullReport={fullReport}
          upgradeReport={upgradeReport}
        />
      </FilterCard>
    )}
    {journalCounts && (
      <FilterCard title='Journals' collapsible>
        <ReportCountFilter
          filterValues={filters.journals}
          filterKey='journals'
          toggleFilter={toggleFilter}
          toggleModal={toggleModal}
          counts={journalCounts}
          fullReport={fullReport}
          upgradeReport={upgradeReport}
        />
      </FilterCard>
    )}
    <FiltersSubmit toggleFilter={toggleFilter} />
  </>
)

export const Filters = ({
  loading = false,
  ...rest
}) => (
  <div className={styles.filters}>
    <Fade className={styles.loadingLayout} show={loading}>
      <CircleSpinner />
    </Fade>
    <FadeVisual show={!loading}>
      <Panels {...rest} />
    </FadeVisual>
  </div>
)

export default Filters
